// Focused loader wrapper: fetches category budgets via getProjectBudgets and
// renders ProjectBudgetSection. Callers must gate mounting on projects.budget.
import { useCallback, useEffect, useState } from "react";
import { T } from "../../../app/tokens.js";
import { getProjectBudgets } from "../../../data/projectsClient.js";
import { ProjectBudgetSection } from "../ProjectBudgetSection.jsx";
import { sx as recSx } from "./RecordSections.jsx";

export function ProjectCategoryBudgets({ projectId, project, canEdit, onEditorState }) {
  const [state, setState] = useState({ status: "loading", items: [], error: null });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setState({ status: "loading", items: [], error: null });
    Promise.resolve().then(() => getProjectBudgets(projectId))
      .then((rows) => { if (!Array.isArray(rows)) throw new Error("The server returned an invalid list."); if (active) setState({ status: "ok", items: rows, error: null }); })
      .catch((error) => { if (active) setState({ status: "error", items: [], error }); });
    return () => { active = false; };
  }, [projectId, retry]);
  const onChange = useCallback((fn) => setState((s) => ({ ...s, items: typeof fn === "function" ? fn(s.items) : fn })), []);

  if (state.status === "loading") {
    return <div data-testid="record-budgets-loading" aria-busy="true" style={{ height: 96, borderRadius: 10, background: T.lightGray }} />;
  }
  if (state.status === "error") {
    return (
      <div role="alert" data-testid="record-budgets-error" style={{ ...recSx.err, marginTop: 0 }}>
        Category budgets unavailable: {state.error?.message || "request failed"}
        <button type="button" data-testid="record-budgets-retry" onClick={() => setRetry((n) => n + 1)} style={{ ...recSx.addLink, color: T.red, marginLeft: 8 }}>Retry</button>
      </div>
    );
  }
  return <ProjectBudgetSection projectId={projectId} project={project} budgets={state.items} canEdit={canEdit} onChange={onChange} onEditorState={onEditorState} />;
}
